import { useState } from 'react';
import './App.css';


function App() {

  const [genPassword, setGenPassword] = useState(''); 
  const [output, setOutput] = useState('Click Button To Generate Password');

  const handleGeneratePassword = () => {
    const length = 16;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!£$%^&*()#@";
    let password = "";
    for (let i = 0; i < length; i++) {
      const at = Math.floor(Math.random() * charset.length);
      password += charset.charAt(at);
    }
    setGenPassword(password);
    setOutput('Password Created');
    
  }

  const handleCopy = () => {
    const copyText = document.getElementById("password");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
    setOutput('Password Copied');
  }

  return (
    <div className="container">
      <h1>Password Generator</h1>
      
      <div className="password-display">
        <input type="text" id="password" value={genPassword} readOnly />

        <button onClick={handleGeneratePassword} id="generate">Generate</button>
        <button onClick={handleCopy} id="copy" style={{backgroundColor: 'green'}}>Copy</button>
      </div>

      <p style={{ color : output === "Password Created" ? 'blue' :'green'} }>{output}</p>
   
    </div>
  );
}

export default App;
